import { Group } from "../models/group.model";
import * as _ from "underscore";
import { GROUP_TYPE } from "./member.helper";
import { MEMBER_TYPE } from "./member.helper";

const countryCodes: any = {
    BD: "+880",
    BE: "+32",
    BF: "+226",
    BG: "+359",
    BA: "+387",
    BB: "+1-246",
    WF: "+681",
    BL: "+590",
    BM: "+1-441",
    BN: "+673",
    BO: "+591",
    BH: "+973",
    BI: "+257",
    BJ: "+229",
    BT: "+975",
    JM: "+1-876",
    BV: "+",
    BW: "+267",
    WS: "+685",
    BQ: "+599",
    BR: "+55",
    BS: "+1-242",
    JE: "+44-1534",
    BY: "+375",
    BZ: "+501",
    RU: "+7",
    RW: "+250",
    RS: "+381",
    TL: "+670",
    RE: "+262",
    TM: "+993",
    TJ: "+992",
    RO: "+40",
    TK: "+690",
    GW: "+245",
    GU: "+1-671",
    GT: "+502",
    GS: "+",
    GR: "+30",
    GQ: "+240",
    GP: "+590",
    JP: "+81",
    GY: "+592",
    GG: "+44-1481",
    GF: "+594",
    GE: "+995",
    GD: "+1-473",
    GB: "+44",
    GA: "+241",
    SV: "+503",
    GN: "+224",
    GM: "+220",
    GL: "+299",
    GI: "+350",
    GH: "+233",
    OM: "+968",
    TN: "+216",
    JO: "+962",
    HR: "+385",
    HT: "+509",
    HU: "+36",
    HK: "+852",
    HN: "+504",
    HM: "+ ",
    VE: "+58",
    PR: "+1-787 and 1-939",
    PS: "+970",
    PW: "+680",
    PT: "+351",
    SJ: "+47",
    PY: "+595",
    IQ: "+964",
    PA: "+507",
    PF: "+689",
    PG: "+675",
    PE: "+51",
    PK: "+92",
    PH: "+63",
    PN: "+870",
    PL: "+48",
    PM: "+508",
    ZM: "+260",
    EH: "+212",
    EE: "+372",
    EG: "+20",
    ZA: "+27",
    EC: "+593",
    IT: "+39",
    VN: "+84",
    SB: "+677",
    ET: "+251",
    SO: "+252",
    ZW: "+263",
    SA: "+966",
    ES: "+34",
    ER: "+291",
    ME: "+382",
    MD: "+373",
    MG: "+261",
    MF: "+590",
    MA: "+212",
    MC: "+377",
    UZ: "+998",
    MM: "+95",
    ML: "+223",
    MO: "+853",
    MN: "+976",
    MH: "+692",
    MK: "+389",
    MU: "+230",
    MT: "+356",
    MW: "+265",
    MV: "+960",
    MQ: "+596",
    MP: "+1-670",
    MS: "+1-664",
    MR: "+222",
    IM: "+44-1624",
    UG: "+256",
    TZ: "+255",
    MY: "+60",
    MX: "+52",
    IL: "+972",
    FR: "+33",
    IO: "+246",
    SH: "+290",
    FI: "+358",
    FJ: "+679",
    FK: "+500",
    FM: "+691",
    FO: "+298",
    NI: "+505",
    NL: "+31",
    NO: "+47",
    NA: "+264",
    VU: "+678",
    NC: "+687",
    NE: "+227",
    NF: "+672",
    NG: "+234",
    NZ: "+64",
    NP: "+977",
    NR: "+674",
    NU: "+683",
    CK: "+682",
    XK: "+",
    CI: "+225",
    CH: "+41",
    CO: "+57",
    CN: "+86",
    CM: "+237",
    CL: "+56",
    CC: "+61",
    CA: "+1",
    CG: "+242",
    CF: "+236",
    CD: "+243",
    CZ: "+420",
    CY: "+357",
    CX: "+61",
    CR: "+506",
    CW: "+599",
    CV: "+238",
    CU: "+53",
    SZ: "+268",
    SY: "+963",
    SX: "+599",
    KG: "+996",
    KE: "+254",
    SS: "+211",
    SR: "+597",
    KI: "+686",
    KH: "+855",
    KN: "+1-869",
    KM: "+269",
    ST: "+239",
    SK: "+421",
    KR: "+82",
    SI: "+386",
    KP: "+850",
    KW: "+965",
    SN: "+221",
    SM: "+378",
    SL: "+232",
    SC: "+248",
    KZ: "+7",
    KY: "+1-345",
    SG: "+65",
    SE: "+46",
    SD: "+249",
    DO: "+1-809 and 1-829",
    DM: "+1-767",
    DJ: "+253",
    DK: "+45",
    VG: "+1-284",
    DE: "+49",
    YE: "+967",
    DZ: "+213",
    US: "+1",
    UY: "+598",
    YT: "+262",
    UM: "+1",
    LB: "+961",
    LC: "+1-758",
    LA: "+856",
    TV: "+688",
    TW: "+886",
    TT: "+1-868",
    TR: "+90",
    LK: "+94",
    LI: "+423",
    LV: "+371",
    TO: "+676",
    LT: "+370",
    LU: "+352",
    LR: "+231",
    LS: "+266",
    TH: "+66",
    TF: "+",
    TG: "+228",
    TD: "+235",
    TC: "+1-649",
    LY: "+218",
    VA: "+379",
    VC: "+1-784",
    AE: "+971",
    AD: "+376",
    AG: "+1-268",
    AF: "+93",
    AI: "+1-264",
    VI: "+1-340",
    IS: "+354",
    IR: "+98",
    AM: "+374",
    AL: "+355",
    AO: "+244",
    AQ: "+",
    AS: "+1-684",
    AR: "+54",
    AU: "+61",
    AT: "+43",
    AW: "+297",
    IN: "+91",
    AX: "+358-18",
    AZ: "+994",
    IE: "+353",
    ID: "+62",
    UA: "+380",
    QA: "+974",
    MZ: "+258",
};
const dictionary = {
    BD: "BGD",
    BE: "BEL",
    BF: "BFA",
    BG: "BGR",
    BA: "BIH",
    BB: "BRB",
    WF: "WLF",
    BL: "BLM",
    BM: "BMU",
    BN: "BRN",
    BO: "BOL",
    BH: "BHR",
    BI: "BDI",
    BJ: "BEN",
    BT: "BTN",
    JM: "JAM",
    BV: "BVT",
    BW: "BWA",
    WS: "WSM",
    BQ: "BES",
    BR: "BRA",
    BS: "BHS",
    JE: "JEY",
    BY: "BLR",
    BZ: "BLZ",
    RU: "RUS",
    RW: "RWA",
    RS: "SRB",
    TL: "TLS",
    RE: "REU",
    TM: "TKM",
    TJ: "TJK",
    RO: "ROU",
    TK: "TKL",
    GW: "GNB",
    GU: "GUM",
    GT: "GTM",
    GS: "SGS",
    GR: "GRC",
    GQ: "GNQ",
    GP: "GLP",
    JP: "JPN",
    GY: "GUY",
    GG: "GGY",
    GF: "GUF",
    GE: "GEO",
    GD: "GRD",
    GB: "GBR",
    GA: "GAB",
    SV: "SLV",
    GN: "GIN",
    GM: "GMB",
    GL: "GRL",
    GI: "GIB",
    GH: "GHA",
    OM: "OMN",
    TN: "TUN",
    JO: "JOR",
    HR: "HRV",
    HT: "HTI",
    HU: "HUN",
    HK: "HKG",
    HN: "HND",
    HM: "HMD",
    VE: "VEN",
    PR: "PRI",
    PS: "PSE",
    PW: "PLW",
    PT: "PRT",
    SJ: "SJM",
    PY: "PRY",
    IQ: "IRQ",
    PA: "PAN",
    PF: "PYF",
    PG: "PNG",
    PE: "PER",
    PK: "PAK",
    PH: "PHL",
    PN: "PCN",
    PL: "POL",
    PM: "SPM",
    ZM: "ZMB",
    EH: "ESH",
    EE: "EST",
    EG: "EGY",
    ZA: "ZAF",
    EC: "ECU",
    IT: "ITA",
    VN: "VNM",
    SB: "SLB",
    ET: "ETH",
    SO: "SOM",
    ZW: "ZWE",
    SA: "SAU",
    ES: "ESP",
    ER: "ERI",
    ME: "MNE",
    MD: "MDA",
    MG: "MDG",
    MF: "MAF",
    MA: "MAR",
    MC: "MCO",
    UZ: "UZB",
    MM: "MMR",
    ML: "MLI",
    MO: "MAC",
    MN: "MNG",
    MH: "MHL",
    MK: "MKD",
    MU: "MUS",
    MT: "MLT",
    MW: "MWI",
    MV: "MDV",
    MQ: "MTQ",
    MP: "MNP",
    MS: "MSR",
    MR: "MRT",
    IM: "IMN",
    UG: "UGA",
    TZ: "TZA",
    MY: "MYS",
    MX: "MEX",
    IL: "ISR",
    FR: "FRA",
    IO: "IOT",
    SH: "SHN",
    FI: "FIN",
    FJ: "FJI",
    FK: "FLK",
    FM: "FSM",
    FO: "FRO",
    NI: "NIC",
    NL: "NLD",
    NO: "NOR",
    NA: "NAM",
    VU: "VUT",
    NC: "NCL",
    NE: "NER",
    NF: "NFK",
    NG: "NGA",
    NZ: "NZL",
    NP: "NPL",
    NR: "NRU",
    NU: "NIU",
    CK: "COK",
    XK: "XKX",
    CI: "CIV",
    CH: "CHE",
    CO: "COL",
    CN: "CHN",
    CM: "CMR",
    CL: "CHL",
    CC: "CCK",
    CA: "CAN",
    CG: "COG",
    CF: "CAF",
    CD: "COD",
    CZ: "CZE",
    CY: "CYP",
    CX: "CXR",
    CR: "CRI",
    CW: "CUW",
    CV: "CPV",
    CU: "CUB",
    SZ: "SWZ",
    SY: "SYR",
    SX: "SXM",
    KG: "KGZ",
    KE: "KEN",
    SS: "SSD",
    SR: "SUR",
    KI: "KIR",
    KH: "KHM",
    KN: "KNA",
    KM: "COM",
    ST: "STP",
    SK: "SVK",
    KR: "KOR",
    SI: "SVN",
    KP: "PRK",
    KW: "KWT",
    SN: "SEN",
    SM: "SMR",
    SL: "SLE",
    SC: "SYC",
    KZ: "KAZ",
    KY: "CYM",
    SG: "SGP",
    SE: "SWE",
    SD: "SDN",
    DO: "DOM",
    DM: "DMA",
    DJ: "DJI",
    DK: "DNK",
    VG: "VGB",
    DE: "DEU",
    YE: "YEM",
    DZ: "DZA",
    US: "USA",
    UY: "URY",
    YT: "MYT",
    UM: "UMI",
    LB: "LBN",
    LC: "LCA",
    LA: "LAO",
    TV: "TUV",
    TW: "TWN",
    TT: "TTO",
    TR: "TUR",
    LK: "LKA",
    LI: "LIE",
    LV: "LVA",
    TO: "TON",
    LT: "LTU",
    LU: "LUX",
    LR: "LBR",
    LS: "LSO",
    TH: "THA",
    TF: "ATF",
    TG: "TGO",
    TD: "TCD",
    TC: "TCA",
    LY: "LBY",
    VA: "VAT",
    VC: "VCT",
    AE: "ARE",
    AD: "AND",
    AG: "ATG",
    AF: "AFG",
    AI: "AIA",
    VI: "VIR",
    IS: "ISL",
    IR: "IRN",
    AM: "ARM",
    AL: "ALB",
    AO: "AGO",
    AQ: "ATA",
    AS: "ASM",
    AR: "ARG",
    AU: "AUS",
    AT: "AUT",
    AW: "ABW",
    IN: "IND",
    AX: "ALA",
    AZ: "AZE",
    IE: "IRL",
    ID: "IDN",
    UA: "UKR",
    QA: "QAT",
    MZ: "MOZ",
};

export default class PhoneNumberHelper {
    static getAlpha3CountryCodeByAlpha2Code(code) {
        return dictionary[code];
    }

    static getAlpha2CountryCodeByAlpha3Code(code) {
        return _.findKey(dictionary, _.partial(_.isEqual, code));
    }

    static stripWhitespace(str) {
        return str ? str.replace(/\s/g, "") : "";
    }

    static compare(a, b) {
        var phoneNumberA = this.stripWhitespace(PhoneNumberHelper.getPhoneNumberWithCountryCode(a));
        var phoneNumberB = this.stripWhitespace(PhoneNumberHelper.getPhoneNumberWithCountryCode(b));

        return phoneNumberA === phoneNumberB;
    }

    static getCountryCodeForRegionCode(regionCode) {
        return countryCodes[regionCode];
    }

    static getCountryCodeForNumber(phoneNumber) {
        try {
            var regionCode = this.getRegionCodeForNumber(phoneNumber);
            return this.getCountryCodeForRegionCode(regionCode);
        } catch (error) {
            return null;
        }
    }
    static getRegionCodeForNumber(phoneNumber) {
        //return phoneUtils.getRegionCodeForNumber(phoneNumber);
    }
    static getAssumedRegionCode() {
        var regionCode = null;
        // var userProfile;
        // try {
        //     userProfile = $injector.get('USER_PROFILE');
        // } catch(e) {
        //     console.error('Unable to inject user profile', e);
        // }

        // if (userProfile && userProfile.countryCode) {
        //     regionCode = this.getAlpha2CountryCodeByAlpha3Code(userProfile.countryCode);
        // }

        // if(_.isEmpty(regionCode) && userProfile && userProfile.phoneNumber){
        //     try {
        //         regionCode = phoneUtils.getRegionCodeForNumber(userProfile.phoneNumber);
        //     } catch (e) { console.error('Unable to determine region code for profile msisdn', e); }
        // }

        // if (_.isEmpty(regionCode) && userProfile && userProfile.requestCountryCode) {
        //     regionCode = userProfile.requestCountryCode.toUpperCase();
        // }

        // // Last resort, map locale to country code
        // if (_.isEmpty(regionCode)) {
        //     var localeToRegionCode = {
        //         'no': 'NO',
        //         'sv': 'SE',
        //         'dk': 'DK',
        //         'de': 'DE'
        //     };

        //     regionCode = localeToRegionCode[userProfile.locale];
        // }

        return regionCode;
    }
    static formatPhoneNumberE164(phoneNumber) {
        return this.formatPhoneNumber(phoneNumber, this.getAssumedRegionCode(), true, true);
    }

    static formatPhoneNumber(
        phoneNumber,
        regionCode: String = undefined,
        alwaysIncludeCountryCode: boolean = false,
        isE164: boolean = false,
    ) {
        if (_.isEmpty(phoneNumber)) {
            return phoneNumber;
        }

        // try{
        //     var validPhoneNumberWithCountryCode = this.getPhoneNumberWithCountryCode(phoneNumber, regionCode);

        //     if(!validPhoneNumberWithCountryCode){
        //         return phoneNumber;
        //     }

        //     var regionCodeForNumber = this.getRegionCodeForNumber(validPhoneNumberWithCountryCode);

        //     if(regionCodeForNumber){
        //         var sanitizedPhoneNumber = this.removeWhitespace(validPhoneNumberWithCountryCode);
        //         if(isE164) {
        //             return phoneUtils.formatE164(sanitizedPhoneNumber);
        //         } else if(!alwaysIncludeCountryCode && regionCode && regionCodeForNumber == regionCode){
        //             return phoneUtils.formatNational(sanitizedPhoneNumber);
        //         } else{
        //             return phoneUtils.formatInternational(sanitizedPhoneNumber);
        //         }
        //     }
        // }
        // catch(error){}

        return phoneNumber;
    }
    static hasRegionCode(phoneNumber) {
        if (_.isEmpty(phoneNumber)) {
            return phoneNumber;
        }

        try {
            if (this.getRegionCodeForNumber(phoneNumber) !== null) {
                return true;
            }
        } catch (error) {}

        return false;
    }
    static removeWhitespace(string) {
        return string.replace(/ /g, "");
    }
    static getPhoneNumberWithoutCountryCode(phoneNumber, regionCode) {
        if (!regionCode || !regionCode || regionCode.length >= phoneNumber.length) {
            return phoneNumber;
        }

        var countryCodeFromPhoneNumber = phoneNumber.substring(0, regionCode.length + 1);
        var countryCode = PhoneNumberHelper.getCountryCodeForRegionCode(regionCode);

        if (countryCodeFromPhoneNumber != countryCode) {
            return phoneNumber;
        }

        return phoneNumber.substring(regionCode.length + 1, phoneNumber.length);
    }

    static getPhoneNumberWithCountryCode(phoneNumber: String, regionCode: String = "") {
        if (regionCode) {
            var countryCode = PhoneNumberHelper.getCountryCodeForRegionCode(regionCode);
            var phoneNumberTestWithAddedCountryCode = countryCode + phoneNumber;
        }

        // try{
        //     // if(phoneNumberTestWithAddedCountryCode && phoneUtils.isValidNumber(phoneNumberTestWithAddedCountryCode)){
        //     //     var validPhoneNumberWithCountryCode = phoneNumberTestWithAddedCountryCode;
        //     // }
        // }
        // catch(e){

        // }

        // try{
        //     // if(!validPhoneNumberWithCountryCode && phoneUtils.isValidNumber(phoneNumber)){
        //     //     var validPhoneNumberWithCountryCode = phoneNumber;
        //     // }
        // }
        // catch(e){

        // }

        // if(validPhoneNumberWithCountryCode){
        //     return validPhoneNumberWithCountryCode;
        // }
        // else{
        //     return false
        // }
    }
}
